/**
 * StaffRoleInfo 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffRoleInfo
 */
export interface StaffRoleInfo {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 删除时间（UTC），goframe会自动处理deleted_at，如果想避免goframe自动处理，请使用Unscoped() */
  deleted_at?: string
  /** 删除原因 */
  deleted_reason?: string
  /** 角色代码，如：admin, editor */
  code?: string
  /** 角色名称，如：超级管理员、编辑 */
  name?: string
  /** 角色描述 */
  description?: string
  /** 是否系统内置角色（不可删除） */
  is_system?: boolean
  /** 排序号 */
  sort?: number
}

/**
 * StaffRoleInfo Schema
 */
export const StaffRoleInfoSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    deleted_at: {
      description:
        '删除时间（UTC），goframe会自动处理deleted_at，如果想避免goframe自动处理，请使用Unscoped()',
      format: '*time.Time',
      type: 'string',
      label: '删除时间',
    },
    deleted_reason: {
      description: '删除原因',
      format: 'string',
      type: 'string',
      label: '删除原因',
    },
    code: {
      description: '角色代码，如：admin, editor',
      format: 'string',
      type: 'string',
      label: '角色代码',
    },
    name: {
      description: '角色名称，如：超级管理员、编辑',
      format: 'string',
      type: 'string',
      label: '角色名称',
    },
    description: {
      description: '角色描述',
      format: 'string',
      type: 'string',
      label: '角色描述',
    },
    is_system: {
      description: '是否系统内置角色（不可删除）',
      format: 'bool',
      type: 'boolean',
      label: '是否系统内置角色',
    },
    sort: {
      description: '排序号',
      format: 'int',
      type: 'integer',
      label: '排序号',
    },
  },
  type: 'object',
}
